import {Select} from "@mantine/core";
import "./CoursesFilter.css";
import {useAppContext} from "../../../context/AppState/AppContext";
import {useEffect, useState} from "react";

const SPECIALTIES = [
    'MEDICINA FELINA',
    'DERMATOLOGÍA',
    'DIAGNÓSTICO POR IMÁGENES-ECOGRAFÍA',
    'DIAGNÓSTICO POR IMÁGENES-RADIOLOGÍA',
    'TERAPIAS FISICAS Y REHABILITACION',
    'CIRUGÍA DE TEJIDOS BLANDOS',
    'TRAUMATOLOGÍA',
    'CARDIOLOGIA',
    'REPRODUCCIÓN Y NEONATOLOGÍA',
    'LABORATORIO Y ANÁLISIS CLÍNICOS',
    'TOXICOLOGÍA',
    'MEDICINA INTERNA',
    'ANESTESIOLOGÍA',
    'UROLOGÍA',
    'CITOLOGÍA',
    'GASTROENTEROLOGÍA'
]

const ACADEMIC_UNITS = [
    'POSGRADO',
    'CURSO',
    'DIPLOMADO',
    'MASTERCLASS',
    'WEBINAR',
    'TALLER'
]

const MONTHS = [
    'ENERO',
    'FEBRERO',
    'MARZO',
    'ABRIL',
    'MAYO',
    'JUNIO',
    'JULIO',
    'AGOSTO',
    'SEPTIEMBRE',
    'OCTUBRE',
    'NOVIEMBRE',
    'DICIEMBRE'
]

const CoursesFilter = (props) => {
    const {
        specialtyFilter,
        setSpecialtyFilter,
        academicUnitFilter,
        setAcademicUnitFilter,
        monthFilter,
        setMonthFilter,
        filterTexts
    } = props;
    const {specialtiesInfo} = useAppContext();
    const [specialtiesOptions, setSpecialtiesOptions] = useState(SPECIALTIES);

    useEffect(() => {
        if (specialtiesInfo?.data) {
            setSpecialtiesOptions(specialtiesInfo?.data.map(specialty => specialty.name.toUpperCase()))
        }
    }, [specialtiesInfo]);

    return (
        <div className="coursesFilter-father-div">
            <div className="coursesFilter-filter-div-container">
                <span className="coursesFilter-span-styling">{filterTexts?.firstFilter}</span>
                <Select
                    size="md"
                    radius="md"
                    value={specialtyFilter} onChange={setSpecialtyFilter}
                    placeholder={specialtiesOptions[0]}
                    clearable
                    searchable
                    nothingFoundMessage="Sin resultados para tu búsqueda"
                    data={specialtiesOptions}
                    classNames={{root: "courserFilter-select-wrapper-customization", input: 'courserFilter-select--input-customization', dropdown: 'courserFilter-dropdown-customization'}}
                />
                <span className="coursesFilter-second-span-styling">
                    {filterTexts?.secondFilter}
                </span>
                <Select
                    size="md"
                    radius="md"
                    value={academicUnitFilter} onChange={setAcademicUnitFilter}
                    placeholder={ACADEMIC_UNITS[0]}
                    clearable
                    searchable
                    nothingFoundMessage="Sin resultados para tu búsqueda"
                    data={ACADEMIC_UNITS}
                    classNames={{root: "courserFilter-select-wrapper-customization", input: 'courserFilter-select--input-customization', dropdown: 'courserFilter-dropdown-customization'}}
                />
                <span className="coursesFilter-second-span-styling">
                {filterTexts?.thirdFilter}
                </span>
                <Select
                    size="md"
                    radius="md"
                    value={monthFilter} onChange={setMonthFilter}
                    placeholder={MONTHS[0]}
                    clearable
                    searchable
                    nothingFoundMessage="Sin resultados para tu búsqueda"
                    data={MONTHS}
                    classNames={{root: "courserFilter-select-wrapper-customization", input: 'courserFilter-select--input-customization', dropdown: 'courserFilter-dropdown-customization'}}
                />
            </div>
        </div>
    );
};
export default CoursesFilter;
